// src/lib/api.js — Axios instance for the RGA CRM API
import axios from 'axios'
import supabase from './supabase'

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 120000,
})

// ── Request interceptor — attach the current Supabase access token ────────
api.interceptors.request.use(async (config) => {
  try {
    const { data, error } = await supabase.auth.getSession()
    if (error) {
      console.warn('[API] getSession error:', error.message)
    }
    const token = data?.session?.access_token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    } else {
      console.warn('[API] No access token available for', config.method?.toUpperCase(), config.url)
    }
  } catch (err) {
    console.error('[API] Failed to attach auth token:', err.message)
  }
  return config
})

// ── Response interceptor — log errors; sign out + redirect on 401 ─────────
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response) {
      console.error(
        `[API] ${error.config?.method?.toUpperCase()} ${error.config?.url}`,
        `→ ${error.response.status}`,
        error.response.data?.error || error.message
      )

      // Token rejected by the API — drop the session and force a fresh login.
      if (error.response.status === 401 && window.location.pathname !== '/login') {
        try { await supabase.auth.signOut() } catch { /* ignore */ }
        window.location.assign('/login')
      }
    } else if (error.request) {
      console.error('[API] No response received — is the server running?', error.message)
    } else {
      console.error('[API] Request setup error:', error.message)
    }
    return Promise.reject(error)
  }
)

export default api
